import { cloneDeep } from "lodash";

let initialState = () => {
  return cloneDeep({
    currentVerificationStep: undefined,
    currentVerificationMethod: undefined,
    activeIcon: undefined,
    allowedVerificationMethods: undefined,
    startedAt: undefined,
    backendAuthorizationStatus: undefined,
  });
};

export default initialState;
